










import { Component, Vue } from 'vue-property-decorator'
import noBindEmail from './noBindEmail.vue'
import onBindEmail from './onBindEmail.vue'
@Component({
  components:{
    noBindEmail,
    onBindEmail
  }
})
export default class BindEmail extends Vue {
  private show :boolean = true
  parentShow(){
    this.show = false
  }
}
